// extracted by mini-css-extract-plugin
module.exports = {"container":"Featured_container__slDhe"};